import {IAdminServiceMode} from 'Admin/AdminAdvancedDashboard/models/IAdminServiceMode';
import {convertUTCToClientDate} from 'Common/helpers/DateHelper';

export function convertServiceModeToClient(serviceMode: IAdminServiceMode): IAdminServiceMode {
  return {
    ...serviceMode,
    modeSettingDate: serviceMode.modeSettingDate ? convertUTCToClientDate(serviceMode.modeSettingDate) || '' : ''
  };
}
